<template>
    <playerList :type="'match_day'"></playerList>
</template>

<script>
import playerList from "@/components/newPlayerList";

export default {
    name: "match_Day",
    components:{
        playerList
    }
}
</script>